import React, { useEffect, useState } from "react";
import GlobalWrapper from "../../../components/Wrapper/GlobalWrapper";
import { Box, Stack } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import GlobalDatagrid from "../../../components/mui/DataGrid/GlobalDatagrid";
import ActionDetails from "../../../components/mui/GlobalAnchor/ActionDetails";
import GlobalAnchorList from "../../../components/mui/GlobalAnchor/GlobalAnchorList";
import { useDispatch, useSelector } from "react-redux";
import dayjs from "dayjs";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import EditBrand from "./EditBrand";
import AddBrand from "./AddBrand";
import { getAllBrands } from "../../../redux/features/assetManagementSlice";
import { Brand_Table_Head } from "../../../components/datagrid/assetmanagement/BrandTableHead";
import DeleteBrand from "./DeleteBrand";
import apiRequest from "../../../api/request";

const Brand = () => {
  const dispatch = useDispatch();
  const { paginationData } = useSelector((state) => state.globalDataGrid);
  const { brandData, loading } = useSelector((state) => state.assetmanagement);
  const { gridSize, pageNum, rowData, openAnchor, search } = paginationData;

  const [value, setValue] = useState(dayjs());

  const data = {
    page: pageNum,
    limit: gridSize,
    brand_status: 0,
    date: dayjs(value).format("YYYY-MM"),
  };

  useEffect(() => {
    if (pageNum) {
      dispatch(getAllBrands(data));
    }
  }, [pageNum, gridSize, value]);

  // Export should include every record, not only the visible page (limit=no returns all rows)
  const fetchAllBrandsForExport = async () => {
    const res = await apiRequest({
      method: "get",
      url: `brands/?page=1&limit=no&brand_status=${data.brand_status}`,
    });
    return res?.data || [];
  };

  return (
    <GlobalWrapper
      title={"Brands"}
      actions={<AddBrand dispatchParams={data} />}
    >
      <Box sx={{ width: "100%", padding: 0 }}>
        <GlobalDatagrid
          tableHead={Brand_Table_Head}
          rows={brandData.data}
          meta={brandData?.meta?.totalRecords || 0}
          loading={loading}
          rowUniqueId="sl_no"
          exportAllRows={fetchAllBrandsForExport}
          rowClick={true}
          actionComponent={
            <>
              <ActionDetails val={rowData?.brand_name} />
              <GlobalAnchorList
                label=""
                component={
                  <EditBrand rowData={rowData} dispatchParams={data} />
                }
              />
              <GlobalAnchorList
                label=""
                component={
                  <DeleteBrand
                    rowData={rowData}
                    data={data}
                    id={rowData?.brand_id}
                  />
                }
              />
            </>
          }
        />
      </Box>
    </GlobalWrapper>
  );
};

export default Brand;
